<ng-container *transloco="let t">
  <div class="mx-auto flex w-full max-w-screen-2xl flex-col gap-4 pt-10">
    <div>
      <div class="text-2xl font-semibold tracking-tight text-gray-800">{{ t("page-title.user_management") }}</div>
      <div class="text-sm font-medium text-gray-500">{{ t("user-management.page_description") }}</div>
    </div>

    <ITabs [tabs]="tabs" [(activeTab)]="selectedTab" />

    @if (selectedTab() === UserManagementTab.USERS) {
      <div class="flex items-center justify-between">
        <div class="w-[30rem]">
          <ISelect
            [options]="organizationOptions()"
            [selectedValue]="selectedOrganization()"
            by="id"
            (selectedOptionChange)="selectedOrganization.set($event.value)"
            searchable
          />
        </div>

        @if (selectedOrganization()?.accessLevel === AccessLevel.ADMIN && selectedOrganization()?.hasSubscription()) {
          <div class="flex items-center gap-2">
            <IDropdown [items]="[addUserOptions]" placement="bottom-end">
              <IButton [label]="t('user-management.add_user')" icon="icon-[lucide--user-plus]" />
            </IDropdown>
          </div>
        }
      </div>

      <div class="ag-theme-quartz w-full flex-1">
        <ag-grid-angular style="width: 100%; height: 75vh" [gridOptions]="gridOptions" [rowData]="gridData()" />
      </div>
    }

    @if (selectedTab() === UserManagementTab.ACTIVITIES) {
      <app-user-activities-grid class="flex-1"></app-user-activities-grid>
    }
  </div>
</ng-container>
